<template>
  <LineChartRenderer :data="lineChartData" :options="lineChartOptions" />
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-moment";
import { useTheme } from "vuetify";

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, TimeScale);

const dataSetOptions = {
  data: [],
  fill: false,
  label: "",
  pointRadius: 5,
  pointHoverRadius: 20,
  borderWidth: 3,
};

const defaultLabel = context => {
  var label = context.dataset.label || "";
  if (label) {
    label += ": ";
  }
  return `${label} ${context.parsed.y}`;
};

export default {
  name: "LineChart",
  components: { LineChartRenderer: Line },
  setup() {
    const theme = useTheme();
    return { theme };
  },
  props: {
    chartData: Array,
    label: Function,
  },
  computed: {
    lineChartData() {
      const c = this.theme.current.value.colors;
      const datasets = this.chartData.map((s, i) => {
        const color = c[`chart-${(i % 5) + 1}`];
        return { ...dataSetOptions, borderColor: color, pointBackgroundColor: color, ...s };
      });
      return {
        datasets,
      };
    },
    lineChartOptions() {
      return {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: this.label || defaultLabel,
            },
          },
        },
        scales: {
          x: {
            type: "time",
            distribution: "series",
            time: { parser: "YYYY-MM-DDTHH:mm", tooltipFormat: "ll" },
            ticks: {
              source: "data",
              maxRotation: 90,
              minRotation: 90,
              autoSkip: false,
              stepSize: 1,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },
      };
    },
  },
};
</script>
